import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
    setFlag,
    setIsPopup,
    setResponseDescription,
    setResponseTitle
} from "../features/responseSlice";
import {Modal} from "react-bootstrap";
import "../../src/utils/Style/component/modals.scss";
import {capitalizeFirstLetters,} from "../features/ValueFormater";
// import QRCodeDisplay from "./QrCodeDisplay";
// import QrDownload from "./QrDownload";
import {roleAuth} from "../utils/functionAuthorization";
import {setActionPayload, setActionType, setShowQrWaitingImage} from "../features/authorizationSlice";
import {ACTION_TYPES} from "../app/actionTypes";


const flagIconMap = {
    0: "/Images/check.png",
    1: "/Images/check.png",
    435: "/Images/warning.png",
    436: "/Images/warning.png",
    437: "/Images/warning.png",
};

function ValidationPopup({onOpenQrAfterGenerate}) {
    const [icon, setIcon] = useState("/Images/caution.png");
    const [copyText, setCopyText] = useState("Copy Code");
    const [qr, setQr] = useState(null);

    const [isOpen, setIsOpen] = useState(false);
    const onOpen = () => setIsOpen(true);
    const onClose = () => setIsOpen(false);

    const inputRef = useRef(null);

    const {
        flag,
        responseTitle,
        responseDescription,
        isPopup,
        info
    } = useSelector((state) => state.transferResponse);

    const {
        showQrWaitingImage
    } = useSelector((state) => state.authorization);

    useEffect(()=>{
        if(info.GlobalCode === 7){
            setTimeout(()=> {
                inputRef.current.style.position = 'static'; 
                inputRef.current.focus();
            }, 100);
        }
    }, [info]);

    const dispatch = useDispatch();

    useEffect(() => {
        if (isPopup) {
            onOpen();
        } else {
            onClose();
        }
    }, [flag, isPopup, onOpen, onClose]);


    const onClosePopup = () => {
        dispatch(setFlag(null));
        dispatch(setIsPopup(false));
        dispatch(setResponseTitle(null));
        dispatch(setResponseDescription(null));
        dispatch(setShowQrWaitingImage(false));
        onClose();
    }

    useEffect(() => {
        if (flag !== null) {
            const iconPath = flagIconMap[Number(flag)] || "/Images/caution.png";
            setIcon(iconPath);
        }

    }, [flag]);

    function copyCodeToClipboard() {
        // Create a new textarea element to temporarily hold the code
        const textarea = document.createElement('textarea');
        textarea.data = info.Code;

        // Append the textarea to the DOM
        document.body.appendChild(textarea);
        textarea.select();

        try {
            navigator.clipboard.writeText(info.Code);
            setCopyText("Code Copied");
        } catch (err) {
            setCopyText("Copy Code");
        }

        // Remove the textarea from the DOM
        document.body.removeChild(textarea);
    }


    return (
        <Modal centered show={isOpen} onHide={onClosePopup}>
            <Modal.Body>
                <div className="header">
                    <div className="modal-header-image">
                        <img src={icon} alt=""/>
                    </div>
                    <div className={info?.GlobalCode === 6 ? "cashin-text" : ""}>{responseTitle}</div>

                </div>
                <div className="response-message">
                    <div className={info?.GlobalCode === 6 ? "cashin-text" : ""}>{responseDescription}</div>
                </div>


                {
                    info?.GlobalCode === 5 &&
                    <div className="cashout-popup">
                        <div className="title">Amount</div>
                        <div className="data">{info.Amount}</div>

                        <div className="title">Receiver Name</div>
                        <div className="data">{capitalizeFirstLetters(info.ReceiverName)}</div>

                        <div className="code-title">Use this code at any BOB outlet to cash out:</div>
                        <div className="code">{info.Code}</div>

                        <button id="closeModalBtn" onClick={copyCodeToClipboard}>{copyText}</button>
                    </div>
                }

                {
                    info?.GlobalCode === 6 &&
                    <div className="cashout-popup">
                        {info?.CashoutType === 2 &&
                            <div className="response-message mt-3">
                                <div className="cashin-text">Kindly show the below QR to the Suyool courier to confirm
                                    the funds pick up.
                                </div>
                            </div>
                        }

                        {
                            (
                                (info?.Method === "cashout" && roleAuth("cashout", "DOWNLOAD_CONFIRMATION_QR_CASH_OUT"))
                                || (info?.Method === "cashin" && roleAuth("cashin", "DOWNLOAD_CONFIRMATION_QR_CASH_IN"))
                            ) &&
                            <>
                                {/* {info.QRCode &&
                                    <QRCodeDisplay link={info.QRCode}/>
                                } */}

                                <div className="qr-text">The QR is saved on your dashboard</div>

                                <button id="closeModalBtn" onClick={() => {
                                    setQr(info?.QRCode);
                                }
                                }>Download QR
                                </button>
                            </>
                        }


                        <button className="skip" onClick={() => {
                            onClosePopup();
                        }}>
                            Skip
                        </button>

                        {/* <QrDownload qrCodeData={qr} setQrData={setQr}/> */}
                    </div>
                }

                {
                    //waiting qr popup
                    info?.GlobalCode === 7 && showQrWaitingImage &&
                    <img className="qr-waiting" src="/Images/Scan-Suyool-QR-Code-500x500.gif" alt=""/>
                }

                {
                    info?.GlobalCode !== 7 &&
                    <div className="centered">
                        <button
                            id="closeModalBtn"
                            onClick={() => {
                                onClosePopup();
                            }}
                        >
                            OK
                        </button>
                    </div>
                }

            </Modal.Body>
        </Modal>
    );
}

export default ValidationPopup;
